module.exports = __webpack_public_path__ + "static/img/product_images_01.d19fb6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/chataxera/product_images_01.png
// module id = D1uF
// module chunks = 34